module.exports = __webpack_public_path__ + "img/summerCamp-method2.bf8b410e.png";